export default __webpack_public_path__ + "static/media/sports14.f799a6a0.jpg";